import { ReactNode } from "react";

interface ResultRowProps {
    label: string;
    value: ReactNode;
    rowClassName?: string;
    labelClassName?: string;
}

export default function ResultRow({ label, value, rowClassName, labelClassName }: ResultRowProps) {
    return (
        <div className={`result-row ${rowClassName ?? ""}`.trim()}>
            <label className={labelClassName}>{label}</label>
            <div className='result'>{value}</div>
        </div>
    );
}
